import { useAuth0 } from "@auth0/auth0-react";
import { Navigate, useLocation } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const internalDocsPath = "/internal/docs";

function LoginComponent() {
  let location = useLocation();
  // from can be a string path (e.g., "/internal/new-request?embedded=true")
  // or an object with pathname (legacy). Normalize to string.
  const stateFrom = location.state?.from;
  const from: string = typeof stateFrom === "string"
    ? stateFrom
    : stateFrom?.pathname || "/dashboards/home";

  const query = useQuery();
  const docsRedirect = query.get("docsRedirect");
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  if (!isAuthenticated) {
    if (docsRedirect) {
      loginWithRedirect({
        appState: {
          returnTo: internalDocsPath,
        },
      }).then();
      return null;
    }

    loginWithRedirect({
      appState: {
        returnTo: from,
      },
    }).then();
    return null;
  } else {
    return <Navigate to={docsRedirect ? internalDocsPath : from} />;
  }
}

export default LoginComponent;
